import {
    OnboardingPage,
    OnboardingPageBody,
    OnboardingPageContent,
    OnboardingPageCopy,
    OnboardingPageFooter,
  } from '@thrivetribe/mvf.ui.organisms.onboarding-page';
  import { Helmet } from 'react-helmet-async';
  import { Button } from '@thrivetribe/mvf.ui.atoms.button';
  import './ForgottenPassword.scss';
  import { ButtonArrow } from '@thrivetribe/mvf.assets.icons.button-arrow';
  import { useNavigate, useSearchParams } from 'react-router-dom';
  import { ImagesUrl } from 'configs/EnvironmentConfig';
  import { resendForgottenPasswordEmail } from 'helpers/sendForgotPasswordEmail';
import { update_forgotten_password_token } from 'redux/forgottenPasswordSlice';
import { useDispatch } from 'react-redux';
  
  export const ForgottenPasswordExpired = () => { 
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    let token  = searchParams.get('token') ?? "";

    const resendPasswordResetEmail = async () => {  
      dispatch(update_forgotten_password_token(token));
      await resendForgottenPasswordEmail(token);
      navigate('/reset-password');
    };
  
    return (
      <OnboardingPage
        hideProfile
        image={`${ImagesUrl}/football.webp`}
        title={'Reset your password'}
      >
        <Helmet>
          <title>Password reset - Email time out</title>
        </Helmet>
        <OnboardingPageContent hasStickyFooter>
          <OnboardingPageBody>
            <OnboardingPageCopy>
              <h1>Uh Oh! Time Out</h1>
              <p>Looks like the link we sent you has expired.</p>
              <p>
                Don't worry, we'll send you a new one. Go, go, go, the link will
                expire in 10 minutes.
              </p>
            </OnboardingPageCopy>
          </OnboardingPageBody>
          <OnboardingPageFooter>
            <Button onClick={resendPasswordResetEmail} variant="primary">
              Send new link <ButtonArrow />
            </Button>
          </OnboardingPageFooter>
        </OnboardingPageContent>
      </OnboardingPage>
    );
  };